"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clozeRegexForNum = void 0;
function clozeRegexForNum(num) {
    return new RegExp("{card".concat(num, ":(.*?)}"), "g");
}
exports.clozeRegexForNum = clozeRegexForNum;
